import { Typography } from '@mui/material'
import React, { ReactNode } from 'react'

import { AccordionSectionWrapper } from '@f-fertighaus/applications/Next/components/fertighaus/AccordionSection/AccordionSection.styled'

interface Props {
  headline: string
  description: string
  children?: ReactNode
}

export const AccordionSection = (props: Props) => {
  return (
    <AccordionSectionWrapper>
      <Typography
        variant='body1'
        fontWeight='fontWeightBold'
        sx={{ marginBottom: 2 }}>
        {props.headline}
      </Typography>
      <Typography variant='body2'>{props.description}</Typography>
      {props.children}
    </AccordionSectionWrapper>
  )
}
